import { acceptInviteMember } from "apis/member-invites/member-invites";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AlertModal from "uis/modal/alert-modal";
import { LoadingModal } from "uis/modal";

const InviteLink = () => {
  const location = useLocation();
  const code = new URLSearchParams(location.search).get("code");
  const [isRequestSent, setIsRequestSent] = useState(false);
  const [openInviteModal, setOpenInviteModal] = useState(false);

  useEffect(() => {
    if (code && !isRequestSent) {
      setOpenInviteModal(true);
    }
  }, []);

  return (
    <>
      <LoadingModal modalIsOpen={true}></LoadingModal>
      <AlertModal
        title={"워크스페이스 초대를 수락하시겠습니까?"}
        content={"수락 시, 워크스페이스 내 멤버로 등록됩니다."}
        onChange={() => {
          if (code && !isRequestSent) {
            setIsRequestSent(true);
            acceptInviteMember(code).then((res) => {
              if (res.success) {
                alert("초대가 성공적으로 수락되었습니다.");
                window.location.href = "/workspace/list";
                return;
              } else {
                if (res.statusCode === 404) {
                  window.location.href = "/sign-up?code=" + code;
                } else {
                  alert("만료된 초대 링크입니다.");
                  window.close();
                }
                return;
              }
            });
          }
        }}
        btnTitle="수락하기"
        modalIsOpen={openInviteModal}
        closeModal={() => {}}
        zIndex={1011}
      />
    </>
  );
};

export default InviteLink;
